import { MedicalOption, MedicalOptionGroupCode } from './medicalOption.model';
import { ID } from '@ianesthesie-kit/services';
import { OptionsCacheManager } from './optionsCacheManager';

export class MedicalOptionService {
  private static readonly INSTANCE = new MedicalOptionService();
  private cacheManager: OptionsCacheManager;

  private constructor() {
    this.cacheManager = new OptionsCacheManager();
  }

  public static getInstance(): MedicalOptionService {
    return this.INSTANCE;
  }

  public getGroupOptionsSync(
    groupCode: MedicalOptionGroupCode
  ): MedicalOption[] {
    if (!groupCode) {
      throw new Error('Group code cannot be undefined');
    }

    if (!this.cacheManager.isInitialized()) {
      return [];
    }

    const cache = this.cacheManager.getCache();
    const groupEntry = cache.groups[groupCode];
    if (!groupEntry) {
      throw new Error(`Group ${groupCode} was not present in cache`);
    }

    return this.denormalizeGroupOptions(groupCode, cache);
  }

  public async getGroupOptions(
    groupCode: MedicalOptionGroupCode
  ): Promise<Omit<MedicalOption, 'id'>[]> {
    return this.cacheManager.get((cache) =>
      this.denormalizeGroupOptions(groupCode, cache)
    );
  }

  private denormalizeGroupOptions(
    groupCode: MedicalOptionGroupCode,
    cache: OptionsCache
  ): MedicalOption[] {
    const group = cache.groups[groupCode];
    if (!group) {
      // TODO sentry
      // TODO handle error
      throw new Error(`Group code does not exist: ${groupCode}`);
    }
    return group.optionIds.map((id) => cache.options[id]);
  }
}

type OptionsCache = {
  groups: {
    [key in MedicalOptionGroupCode]?: {
      optionIds: ID[];
    };
  };
  options: {
    [id: ID]: MedicalOption;
  };
};
